var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoModalTelenetbase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 36,
    fill: "#EEEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15622_161476)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9157 34V54H22V34H66.9157ZM65.2819 35.6492H23.6338V52.3508H65.2819V35.6492Z",
    fill: "#009793"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.542 39.1309C51.4611 39.1309 52.9652 40.2042 52.9652 41.9057V42.3508H50.7089V42.0105C50.7089 41.4869 50.3459 40.9372 49.568 40.9372C48.7641 40.9372 48.4787 41.4607 48.4787 41.8796C48.4787 42.5602 48.9454 42.8743 49.6717 43.0052C52.602 43.5811 53.1727 44.3403 53.1727 45.9895C53.1727 47.7434 51.5906 48.9214 49.5939 48.9214C47.1563 48.9214 46.0151 47.7434 46.0411 46.0419V45.6754H48.4528V46.068C48.4528 46.5392 48.7122 47.0628 49.568 47.0628C50.2941 47.0628 50.657 46.644 50.657 46.068C50.657 45.4136 50.1903 45.1256 49.4642 45.0209C46.845 44.5759 46.1448 43.5288 46.1448 41.9843C46.1448 40.3612 47.623 39.1309 49.542 39.1309ZM61.6268 39.3403V41.2251H57.9183V43.0052H61.523V44.7068H57.9183V46.8534H61.6268V48.712H55.5844V39.3403H61.6268ZM40.1024 39.1309C42.0215 39.1309 43.6553 40.2565 43.6553 43.0052V48.712H41.2953V45.5183H38.9354V48.712H36.5496V43.0052C36.5496 40.2565 38.1575 39.1309 40.1024 39.1309ZM31.1815 39.3141C32.9709 39.3141 34.1379 40.4921 34.1379 41.9057C34.1379 42.5602 33.5673 43.4241 33.0746 43.6858V43.712C34.0601 44.157 34.475 44.9162 34.475 45.8063C34.475 47.534 33.1005 48.712 31.0259 48.6858H27.2656V39.3141H31.1815ZM30.974 44.6806H29.6255V47.0366H30.974C31.752 47.0366 32.2188 46.5392 32.2188 45.8586C32.2188 45.0471 31.6483 44.6806 30.974 44.6806ZM40.0765 41.0419C39.4541 41.0419 38.9354 41.3822 38.9354 42.4031V43.712H41.2953V42.4031C41.2953 41.4084 40.7248 41.0419 40.0765 41.0419ZM31.0518 41.068H29.6255V43.0576H31.0518C31.5186 43.0576 31.9076 42.6125 31.9076 42.0628C31.9076 41.4869 31.5186 41.068 31.0518 41.068Z",
    fill: "#009793"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15622_161476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 20,
    fill: "white",
    transform: "translate(22 34)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoModalTelenetbase);
export default __webpack_public_path__ + "static/media/logoModalTelenetbase.c1138ff3c01c75d75c95bd4f0f284a19.svg";
export { ForwardRef as ReactComponent };